import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { TRANSLATIONS, DEFAULT_LANG, LANGS } from "./translations";
import { SERVICE_ITEM_TRANSLATIONS, translatePrice } from "./serviceTranslations";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const stored = window.localStorage.getItem("nava_lang");
    if (stored && LANGS.some((l) => l.code === stored)) return stored;
    return DEFAULT_LANG;
  });

  const setLang = useCallback((code) => {
    setLangState(code);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("nava_lang", code);
      document.documentElement.setAttribute("lang", code);
    }
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = useCallback(
    (key) => {
      const entry = TRANSLATIONS[key];
      if (!entry) return key;
      return entry[lang] || entry[DEFAULT_LANG] || key;
    },
    [lang]
  );

  const tName = useCallback(
    (germanName) => {
      const entry = SERVICE_ITEM_TRANSLATIONS[germanName];
      if (!entry) return germanName;
      return entry[lang] || entry[DEFAULT_LANG] || germanName;
    },
    [lang]
  );

  const tPrice = useCallback((price) => translatePrice(price, lang), [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t, tName, tPrice }}>
      {children}
    </LangContext.Provider>
  );
}

export const useT = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
};
